<template>
  <div>
    <app-navbar></app-navbar>
    <router-view></router-view>
    <portal-target name="flyout-sidebar" slim />
  </div>
</template>

<script>
import AppNavbar from "@/components/AppNavbar";

export default {
  components: {
    AppNavbar
  }
};
</script>